import { SkeletonSpinnerCentered } from '@civilgrid/ui/SkeletonLoader';
import { useParams } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { capturePosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import type { ProjectFile } from './common';

interface Props {
  file: ProjectFile;
  type: 'image' | 'video' | '';
}

export default function MediaViewer({ file, type }: Props) {
  const [loading, setLoading] = useState(false);
  const { projectId } = useParams({ strict: false }) as { projectId: string };

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    setLoading(true);

    // only fire the tracking when this first mounts, one mount = one view.
    capturePosthogEvent(POSTHOG_EVENTS.projectFileViewed, {
      project_id: projectId,
      filetype: type || 'media',
    });
  }, []);

  return (
    <div className="relative w-full grow">
      {/* we only show the loading spinner for images - the video element comes with its own loading indicator */}
      {type === 'image' && loading && <SkeletonSpinnerCentered />}

      {type === 'image' ? (
        <img
          src={file.path}
          alt={file.name || 'Media attachment'}
          className="h-full w-full object-contain"
          onLoad={() => setLoading(false)}
        />
      ) : (
        <video src={file.path} className="h-full w-full object-contain" controls onLoadedData={() => setLoading(false)}>
          <track kind="captions" />
        </video>
      )}
    </div>
  );
}
